import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }
  .desktop-icon.topLogoIcon {
    width: 156px;
    height: 89px;
    margin-top: -33px;
}
.blueBorder{
    width: 436px;
    max-width: 100%;
  }
`

export default GlobalStyle
